import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cn } from 'modules/Common/utils/cn';

/**
 * Tailwind-native replacement for react-bootstrap's border Spinner
 * (tailwind-standardization phase 3). Color comes from `currentColor`, so set
 * it with a text-* class or a `style.color` on the spinner or its parent.
 *
 * Sizes mirror the two Bootstrap variants used in this codebase: default
 * (2rem) and `size="sm"` (1rem). Pass className for exact pixel overrides.
 */
export default function CgSpinner({ size, className, style, ...rest }) {
  const { t } = useTranslation('common');
  return (
    <div
      role="status"
      aria-label={t('common:states.loading', 'Loading')}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        size === 'sm' ? 'h-4 w-4 border-2' : 'h-8 w-8 border-[3px]',
        className,
      )}
      style={style}
      {...rest}
    />
  );
}

CgSpinner.propTypes = {
  size: PropTypes.oneOf(['sm']),
  className: PropTypes.string,
  style: PropTypes.object,
};
